import React from "react";
import "./AssignDriverAndCar.css";
import { useState, useEffect } from "react";
import ApiManager from "../../ApiManager/ApiManager";
import { useComponentLoading } from "../../utils/useComponentLoading";
import { LoadingSpinner } from "../../components/LoadingSpinner/LoadingSpinner";

const AssignDriverAndCar = ({ tripId, onSuccess }) => {
  const [drivers, setDrivers] = useState([]);
  const [cars, setCars] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState("");

  const { isLoading, startLoading, stopLoading, withLoading } = useComponentLoading({
    fetchDrivers: false,
    fetchCars: false,
    assignDriverAndCar: false,
  });

  useEffect(() => {
    const fetchDrivers = async () => {
      await withLoading('fetchDrivers', async () => {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllDrivers(params);
        if (!response.ok) throw new Error('Network response was not ok');
        const json = await response.json();
        setDrivers(json || []);
      }, 'Loading drivers...');
    };

    const fetchCars = async () => {
      await withLoading('fetchCars', async () => {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllCars(params);
        if (!response.ok) throw new Error('Network response was not ok');
        const json = await response.json();
        setCars(json || []);
      }, 'Loading cars...');
    };

    fetchDrivers();
    fetchCars();
  }, []);

  const handleCarChange = (e) => {
    const selectedCar = cars.find(car => car.id === parseInt(e.target.value));
    if (selectedCar && selectedCar.assignedDriverId) {
      setSelectedDriver(selectedCar.assignedDriverId.toString());
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    startLoading('assignDriverAndCar');
    try {
      const formData = new FormData(e.target);
      const inputData = Object.fromEntries(formData.entries());
      const params = new URLSearchParams({
        tripId: tripId,
        driverId: inputData.driver,
        carId: inputData.car
      });
      const response = await ApiManager.assignDriverAndCar(params);
      if (!response.ok) {
        throw new Error("Failed to book the trip");
      }
      onSuccess();
    } catch (error) {
      console.error("Error in assigning driver and car:", error);
    } finally {
      stopLoading('assignDriverAndCar');
    }
  };

  if (isLoading('fetchDrivers') || isLoading('fetchCars')) {
    return (
        <LoadingSpinner 
          message="Loading drivers and cars..."
        />
    );
  }

  return (
    <div className="assign-driver-and-car">
      {isLoading('assignDriverAndCar') && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="formGroup">
          <label>Car *</label>
          <select
            name="car"
            required
            className="input"
            disabled={isLoading('fetchCars')}
            onChange={handleCarChange}
          >
            <option value="">Select a Car</option>
            {cars.map((car) => (
              <option key={car.id} value={car.id}>
                {car.vehicleNo}
              </option>
            ))}
          </select>
          {isLoading('fetchCars') && <p>Loading cars...</p>}
        </div>

        <div className="formGroup">
          <label>Driver *</label>
          <select
            name="driver"
            required
            className="input"
            disabled={isLoading('fetchDrivers')}
            value={selectedDriver}
            onChange={(e) => setSelectedDriver(e.target.value)}
          >
            <option value="">Select a Driver</option>
            {drivers.map((driver) => (
              <option key={driver.id} value={driver.id}>
                {driver.username}
              </option>
            ))}
          </select>
          {isLoading('fetchDrivers') && <p>Loading drivers...</p>}
        </div>

        <button type="submit" className="submitButton">
          Submit
        </button>
      </form>
    </div>
  );
};

export default AssignDriverAndCar;